// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1k63B","fileBtn":"File_fileBtn__1ZTTy","closeBtn":"File_closeBtn__1LM5l","fileSelected":"File_fileSelected__25BCW","disabled":"File_disabled__MiHVP"};